import { createVideoAdapter } from '../../shared/video/adapter/adapter';
import { selectMediaAssetCreatorVideoState } from '../media-asset-creator.selectors';

export const mediaAssetCreatorVideoAdapter = createVideoAdapter({
  stateKeyOrSelector: selectMediaAssetCreatorVideoState,
  type: 'Media Asset Creator Video',
});
